import $ from 'jquery';

export function playVideo() {
    const playButton = $('.play');

    playButton.on('click', function () {
        const parent = $(this).siblings('.review-slider__video');

        const _self = this;

        parent.each(function(i, el) {
            const videoItem = el;

            if (videoItem.paused) {
                videoItem.play();
                $(_self).addClass('play-start');
            } else {
                videoItem.pause();
                $(_self).removeClass('play-start');
            }
        })
    })
}


// WEBPACK FOOTER //
// app/scripts/components/play-video.js